import React from 'react'
import { Spinner } from '@/components/spinner';
import { ChecklistReportWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { ChecklistReportWizardResult } from './Result';

const maxStep = 2

export const ChecklistReportWizardBody = () => {
  const { step } = useWizard()

  if (step === 0) {
    return <ChecklistReportWizardStep1 />
  } else if (step === 1) {
    return <ChecklistReportWizardResult />
  } else return <Spinner />
}

export const ChecklistReportWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='checklist-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <ChecklistReportWizardBody />
    </WizardProvider>
  </div>
}

export const ChecklistReportWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <ChecklistReportWizard onDone={onClose} />
}
